import React from "react"
import { InputBoxWithLabelAndDescriptionProps } from "../types/input"

export const InputBoxWithLabelAndDescription = (props: InputBoxWithLabelAndDescriptionProps) => {

    return (
        <div className="col-lg-7 col-12 mb-3">
            <label htmlFor={props.name}>
                {props.label}
            </label>
            <div>
                <input
                    type="text"
                    disabled={!props.onChangeCallback || props.disabled}
                    className="form-control"
                    id={props.name}
                    name={props.name}
                    value={props.value}
                    onChange={props.onChangeCallback}
                />
            </div>
            <small className="form-text text-muted">
                {props.description}
            </small>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/common/inputs/InputBoxWithLabelAndDescription.tsx